var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"sidebar-column"},[_vm._t("sidebar")],2),_c('div',{staticClass:"main-column"},[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }